/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */
import { N0, N200, N40A, N50A, N60A, N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line import/order, import/order, @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from 'styled-components';
import { rootAbsoluteLineHeight } from '../theme';

/*
 * Usage:
 *
 * const StyledDiv = styled.div`
 *   ${ ellipsis };
 * `;
 */
export const ellipsis = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
export const twoLineEllipsis = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ellipsisInFlexChild = css`
	min-width: 0;
	${ellipsis};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const paragraphTypography = css`
	font-size: 14px;
	font-weight: 400;
	letter-spacing: -0.005em;
	color: ${token('color.text', N800)};
	line-height: 20px;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const smallTextTypography = css`
	color: ${token('color.text.subtlest', N200)};
	font-size: 12px;
	line-height: ${14 / 12};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const linkShadowItem = css`
	background: ${token('elevation.surface.raised', N0)};
	border-radius: ${token('border.radius.100', '3px')};
	transition: box-shadow 0.25s ease;
	box-shadow: ${token('elevation.shadow.raised', `0 1px 1px ${N50A}, 0 0 1px 1px ${N40A}`)};

	&:hover,
	&.active {
		box-shadow: ${token('elevation.shadow.overlay', `0 4px 8px -2px ${N50A}, 0 0 1px ${N60A}`)};
	}
`;

// This is not cross-browser.
// http://caniuse.com/#feat=css-line-clamp
// For unsupported browsers, the text is simply clipped.
export const MultilineEllipsis = (maxLines = 1, lineHeight = rootAbsoluteLineHeight) => css`
	overflow: hidden;
	-webkit-line-clamp: ${maxLines};
	-webkit-box-orient: vertical;
	display: -webkit-box;
	text-overflow: ellipsis;

	// fallback for non-webkit browsers:
	max-height: ${maxLines * lineHeight}px;
`;
